"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTooltipTheme = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BarsWrapper = _interopRequireDefault(require("./components/BarsWrapper"));
var _OrderItemsText = _interopRequireDefault(require("./components/OrderItemsText"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InstalmentsBar = function InstalmentsBar(_ref) {
  var items = _ref.items,
    currency = _ref.currency,
    fullyPaid = _ref.fullyPaid,
    amountToPayPercentage = _ref.amountToPayPercentage,
    showCurrency = _ref.showCurrency,
    totalGross = _ref.totalGross;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    itemsColours = _useState2[0],
    setItemsColours = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-instalments-bar"
  }, /*#__PURE__*/_react["default"].createElement(_BarsWrapper["default"], {
    items: items,
    currency: currency,
    amountToPayPercentage: amountToPayPercentage,
    itemsColours: itemsColours,
    fullyPaid: fullyPaid,
    showCurrency: showCurrency
  }), /*#__PURE__*/_react["default"].createElement(_OrderItemsText["default"], {
    items: items,
    currency: currency,
    showCurrency: showCurrency,
    fullyPaid: fullyPaid,
    setItemsColours: setItemsColours,
    totalGross: totalGross
  }));
};
var getTooltipTheme = exports.getTooltipTheme = function getTooltipTheme(colourClassName) {
  var theme = 'dark';
  switch (colourClassName) {
    case 'd8-u-primary-bg':
      theme = 'primary';
      break;
    case 'd8-u-primary-lighter-bg':
      theme = 'primary-lighter';
      break;
    case 'd8-u-error-bg':
      theme = 'error';
      break;
    case 'd8-u-success-dark-bg':
      theme = 'success-dark';
      break;
    default:
      theme = 'dark';
  }
  return theme;
};
InstalmentsBar.propTypes = {
  items: _propTypes["default"].object.isRequired,
  currency: _propTypes["default"].string.isRequired,
  showCurrency: _propTypes["default"].string,
  fullyPaid: _propTypes["default"].bool.isRequired,
  amountToPayPercentage: _propTypes["default"].number,
  totalGross: _propTypes["default"].number
};
var _default = exports["default"] = InstalmentsBar;